export const data = [
  {
    title: "Definición",
    icon: "fas fa-project-diagram",
    content: `<span class="Certification-text">
    Certifica la idoneidad profesional para ejercer tareas de
    planificación financiera personal integral de alto nivel de
    complejidad y volumen.
  </span>`,
  },
  {
    title: "Estructura examen",
    icon: "fas fa-list",
    content: `<span class="Certification-text">Constará de 2 partes:</span> 
    <span class="Certification-text">Una primera parte, consiste en un test de cincuenta preguntas de opción múltiple sobre aquellas materias recogidas en el Programa de EFP. Para obtener la calificación de Apto será requisito el haber respondido correctamente al menos el 70% del examen (35 preguntas). Las respuestas incorrectas o en blanco no restan puntos. Duración de la primera parte: 2 horas.</span> 
    <span class="Certification-text">Una segunda parte, en la que el candidato deberá demostrar los conocimientos y la capacidad de análisis y aplicación sobre todas aquellas materias que aparecen en el Programa de Certificación EFP más las incluidas en los anexos del Programa (puntos 3 y 4) y consistirá en la resolución de uno o varios casos prácticos globales sobre Planificación Financiera, donde el candidato deberá demostrar sus habilidades y conocimientos en relación a los siguientes aspectos:</span>
    <ul>
        <li>Recopilación de los datos del cliente.</li>
        <li>Identificar sus necesidades y posibles soluciones.</li>
        <li>Hacer análisis y recomendaciones.</li>
        <li>Presentación del Plan financiero al cliente.</li>
    </ul>
    <span class="Certification-text mb-0">Duración de la segunda parte: 4 horas.</span>
    <span class="Certification-text">Deben aprobarse ambas partes.</span>`,
  },
]

export const requirements = [
  {
    title: "Requisitos",
    icon: "far fa-check-square",
    content: `<ol class="numeros engancha">
    <li>Se requiere 1 año de experiencia o bien, 6 meses, si el candidato ha realizado un curso de preparación en un centro Acreditado. </li>
    <li>Carecer de antecedentes penales por delitos dolosos, no haber sido objeto de expulsión en colegio o asociación profesional y no habérsele impuesto sanción firme por infracción grave en la CNMV.</li>
    <li>Estar en posesión vigente de la certificación de Asesor Financiero Europeo (EFA).</li>
    <li>Los inscritos que superen el examen recibirán información sobre los requisitos para la concesión de su certificación EFPA. La documentación a aportar les aparecerá en la Web, dentro de su espacio "Acceso Inscripción a Exámenes" en la carpeta "Mis exámenes" cuando consulten su nota.</li>
    </ol> 
    <span class="Certification-text">O bien, disponer de alguna de las certificaciones/ titulaciones profesionales siguientes, siempre que hayan sido obtenidas en los diez últimos años: CFA, CEFA, FRM, CAIA, CIIA, PRMIA, CFP.</span>`,
  },
]

export const certificationEfaTest = [
  {
    title: "Definición",
    icon: "fas fa-pen-square",
    content: `<span class="Certification-text">
      Certifica la idoneidad profesional para ejercer tareas de consejo, gestión y asesoría financiera a particulares en banca personal o privada, servicios financieros orientados al cliente individual y cualquier función profesional bancaria, de seguros o independiente, que implique la oferta de un servicio integrado de asesoría patrimonial y financiera.
  </span>
  <span class="Certification-text">
    La obtención de este certificado puede hacerse a través de un único examen de toda la materia exigida o a través de dos exámenes correspondientes a cada uno de los niveles.
  </span>`,
  },
  {
    title: "Estructura examen",
    icon: "fas fa-list",
    content: `<span class="Certification-text">
    Constará de 2 partes:
  </span>
  <span class="Certification-text">
    La primera, un examen tipo test de 50 preguntas. Para aprobar, el requisito será el haber respondido bien al menos al 70% del examen (35 preguntas). Las respuestas incorrectas o en blanco no restan puntos. Duración de la primera prueba: 1 hora y 30 minutos.
  </span>
  <span class="Certification-text">
    La segunda parte, consistirá en la resolución de ejercicios prácticos sobre distintos aspectos contemplados en el temario EFA. Duración de la segunda prueba: 1 hora.
    En la parte práctica, se valorará no solo la respuesta final seleccionada, sino también la calidad de la explicación y los argumentos en su razonamiento.
  </span>
  <span class="Certification-text font-weight-bold">
    NOTA: La normativa fiscal se aplicará a la correspondiente del país que se realice el examen.
  </span>
  <span class="Certification-text">Deben aprobarse ambas partes.</span>`,
  },
]

export const requirementsEfa = [
  {
    title: "Requisitos",
    icon: "far fa-check-square",
    content: `<ol class="numeros engancha">
      <li>Disponer de:<br>
        <strong> a) Titulación</strong>: Educación secundaria post obligatoria (BUP,  Bachillerato, FP) con  la siguiente <strong>experiencia</strong>: Se  requiere 1 año de experiencia para poder obtener la certificación EFA,  o bien, 6 meses, si el candidato ha realizado un curso de preparación en un  centro acreditado<br>
        <br>
        O bien
        <br>
        <br>
        <strong>b) Titulación:</strong> Educación Secundaria Obligatoria,  con la siguiente experiencia: Se  requieren 5 años de <strong>experiencia</strong> en el sector financiero, debiendo aportar un certificado que lo acredite.\
      </li>
      <li>Carecer de antecedentes penales por delitos dolosos, no haber sido objeto de expulsión en colegio o asociación profesional y no habérsele impuesto sanción firme por infracción grave en la CNMV.</li>
      <li>Realizar la inscripción al examen, a través de la Web, cumplimentando los datos requeridos, adjuntando CV, la última titulación académica obtenida y realizar la transferencia de los derechos de examen para finalizar el proceso.</li>
      <li>Los inscritos que superen el examen recibirán información sobre los requisitos para la concesión de su certificación EFPA. La documentación a aportar les aparecerá en la Web, dentro de su espacio "Acceso Inscripción a Exámenes" en la carpeta "Mis exámenes" cuando consulten su nota.</li>
    </ol>`,
  },
]

export const certificationEipTest = [
  {
    title: "Definición",
    icon: "fas fa-pen-square",
    content: `<span class="Certification-text">
    La certificación EFPA <em>European Investment Practitioner</em> (EIP) tiene reconocimiento y validez de carácter europeo. Es un nivel intermedio y parcial para la obtención de la siguiente certificación de mayor nivel EFA.
  </span>
  <span class="Certification-text">
    Las horas de formación del certificado EIP (200/240) se entienden como 150 horas lectivas (de clase) y 50/90 horas de autoestudio.
  </span>
  <span class="Certification-text">
    Las personas que obtengan esta certificación tendrán que firmar el código ético y declaración de honorabilidad además de aportar 30 horas de formación continua cada año.
  </span>
  <span class="Certification-text">
    La certificación EFPA <em>European Investment Practitioner</em> (EIP) reconoce la cualificación necesaria para ofrecer asesoramiento habitualmente puntual, de acuerdo a las directrices de ESMA y a los criterios que éstas establecen sobre conocimientos y competencias para asesorar en materia de inversión.
  </span>`,
  },
  {
    title: "Estructura examen",
    icon: "fas fa-list",
    content: `<span class="Certification-text">
    El examen EIP consta de 40 preguntas tipo test. Es requisito responder, al menos, el 70% de las preguntas del examen correctamente (28 preguntas), para superar satisfactoriamente la prueba. Las respuestas incorrectas o en blanco no restan puntos. Duración del examen es de 1 hora y 30 minutos.
  </span>
  `,
  },
  {
    title: "Simulación examen",
    icon: "far fa-file-alt",
    content: `<a class="Certification-text" href="https://efpa.es/docs/simulacion_examen_eip.pdf">Simulación examen EIP (ejemplo1)</a>
    <a class="Certification-text" href="https://efpa.es/docs/simulacion_examen_eip2.pdf">Simulación examen EIP (ejemplo2)</a>
  `,
  },
]

export const requirementsEip = [
  {
    title: "Requisitos",
    icon: "far fa-check-square",
    content: `<ol class="numeros engancha">
    <li>Disponer de:<br> 
                 			  <strong> a) Titulación</strong>: Educación secundaria post obligatoria (BUP,  Bachillerato, FP) con  la siguiente <strong>experiencia</strong>: Se  requiere 1 año de experiencia para poder obtener la certificación EIP,  o bien, 6 meses, si el candidato ha realizado un curso de preparación en un  centro acreditado<br>
<br>
                              O bien<br>
                              <br>
                          <strong>b) Titulación:</strong> Educación Secundaria Obligatoria,  con la siguiente experiencia: Se  requieren 5 años de <strong>experiencia</strong> en el sector financiero, debiendo aportar un certificado que lo acredite.</li>
    <li>Carecer de antecedentes penales por delitos dolosos, no haber sido objeto de expulsión en colegio o asociación profesional y no habérsele impuesto sanción firme por infracción grave en la CNMV.</li>
    <li>Realizar la inscripción al examen, a través de la Web, cumplimentando los datos requeridos, adjuntando CV, la última titulación académica obtenida y realizar la transferencia de los derechos de examen para finalizar el proceso.</li>
    <li>Los inscritos que superen el examen recibirán información sobre los requisitos para la concesión de su certificación EFPA. La documentación a aportar les aparecerá en la Web, dentro de su espacio "Acceso Inscripción a Exámenes" en la carpeta "Mis exámenes" cuando consulten su nota.</li>
    </ol>`,
  },
]

export const certificationEiaTest = [
  {
    title: "Definición",
    icon: "fas fa-pen-square",
    content: `<span class="Certification-text">
    La certificación EFPA <em>European Investment Assistant</em> (EIA) tiene reconocimiento y validez de carácter europeo.
  </span>
  <span class="Certification-text">
    Las horas de formación del certificado EIA (100/120) se entienden como 80 horas lectivas (de clase) y 20/40 horas de autoestudio.
  </span>
  <span class="Certification-text">
    Las personas que obtengan esta certificación, tendrán que firmar el código ético y declaración de honorabilidad además de aportar 20 horas de formación cada año (a partir de 2018).
  </span>
  <span class="Certification-text">
    La certificación EFPA <em>European Investment Assistant</em> (EIA) reconoce la cualificación necesaria para ofrecer información de acuerdo a las directrices de ESMA y a los criterios que éstos establecen sobre conocimientos y competencias para proporcionar información en materia de inversión.
  </span>`,
  },
  {
    title: "Estructura examen",
    icon: "fas fa-list",
    content: `<span class="Certification-text">
      El examen EIA consta de 36 preguntas tipo test. Es requisito responder, al menos, el 70% de las preguntas del examen correctamente (25 preguntas), para superar satisfactoriamente la prueba. Las respuestas incorrectas o en blanco no restan puntos. Duración del examen es de 60 minutos.
  </span>
  `,
  },
]

export const requirementsEia = [
  {
    title: "Requisitos",
    icon: "far fa-check-square",
    content: `<ol class="numeros engancha">
    <li>Disponer de:
        <ul>
            <li><strong>a) Titulación</strong>: Educación secundaria post obligatoria (BUP, Bachillerato, FP)</li>
            <li><strong>b) Titulación</strong>: Educación Secundaria Obligatoria, con la siguiente experiencia: Se requieren 5 años de <strong>experiencia</strong> en el sector financiero, debiendo aportar un certificado que lo acredite.</li>
        </ul>
    </li>
    <li>Carecer de antecedentes penales por delitos dolosos, no haber sido objeto de expulsión en colegio o asociación profesional y no habérsele impuesto sanción firme por infracción grave en la CNMV.</li>
    <li>Realizar la inscripción al examen, a través de la Web, cumplimentando los datos requeridos, adjuntando CV, la última titulación académica obtenida y realizar la transferencia de los derechos de examen para finalizar el proceso.</li>
    <li>Los inscritos que superen el examen recibirán información sobre los requisitos para la concesión de su certificación EFPA. La documentación a aportar les aparecerá en la Web, dentro de su espacio "Acceso Inscripción a Exámenes" en la carpeta "Mis exámenes" cuando consulten su nota.</li>
    </ol>`,
  },
]

export const certificationESGTest = [
  {
    title: "Definición",
    icon: "fas fa-pen-square",
    content: `<span class="Certification-text">
    Esta certificación está dirigida a aquellos profesionales del asesoramiento financiero que quieran complementar sus conocimientos y competencias certificadas; y adquirir una cualificación en relación con los factores ESG para la distribución de productos y servicios financieros. Además de poder ofrecer un asesoramiento transversal en el ámbito de las finanzas sostenibles teniendo en cuenta lo que implica y como está incidiendo en los mercados financieros.
    </span>
    <span class="Certification-text">
      El certificado en Asesoramiento en Finanzas Sostenibles (EFPA ESG <em>Advisor</em>™) se caracteriza por:
    </span>
    <ol class="numeros engancha">
    <li>Tener reconocimiento y validez de carácter europeo por EFPA.</li>
    <li>Ser una certificación concebida y planteada para asesores y planificadores financieros.</li>    
    </ol>`,
  },
  {
    title: "Estructura examen",
    icon: "fas fa-list",
    content: `<span class="Certification-text">
    Los conocimientos y competencias de los candidatos que deseen obtener la certificación EFPA ESG <em>Advisor</em>™ serán evaluados en un examen en el que deberán demostrar la asimilación y aplicación práctica de los factores ESG de manera transversal en el contexto del asesoramiento financiero, adaptándose a las tendencias actuales de los mercados financieros.
  </span>
  <span class="Certification-text">
    El examen constará de 30 preguntas tipo test. Para superar satisfactoriamente la prueba es requisito responder correctamente, al menos, al 70% de las preguntas. Las respuestas incorrectas o en blanco no restarán puntos. La duración del examen será de 60 minutos. No se realizarán revisiones de examen
  </span>
  `,
  },
]

export const requirementsESG = [
  {
    title: "Requisitos",
    icon: "far fa-check-square",
    content: `<ol class="numeros engancha">
    <li><p style="margin-bottom:15px">Disponer de:</p> 
      <ul>
        <li style="list-style-type:none;">a) <span style="font-weight:bold;"> <span style="color:red">*</span> Titulación:</span> Educación secundaria post obligatoria (BUP, Bachillerato, FP) con la siguiente experiencia: Se requiere 1 año de experiencia en asesoramiento financiero o temas medioambientales, para poder obtener la Certificación EFPA ESG <em>Advisor™</em>, o bien, 6 meses, si el candidato ha realizado un curso de preparación en un centro acreditado.</li>
        <li style="list-style-type:none;"> O bien </li>
        <li style="list-style-type:none;">b) <span style="font-weight:bold;"><span style="color:red">*</span> Titulación:</span> Educación Secundaria Obligatoria, con la siguiente experiencia: Se requieren experiencia en temas medioambientales o en asesoramiento financiero, debiendo aportar un certificado que lo acredite.</li>
      </ul>
    </li>
    <li>Carecer de antecedentes penales por delitos dolosos, no haber sido objeto de expulsión en colegio o asociación profesional y no habérsele impuesto sanción firme por infracción grave en la CNMV.</li>\n
    <li>Realizar la inscripción al examen, a través de la Web, cumplimentando los datos requeridos, <span style="color:red">*</span>adjuntando CV, la última <span style="color:red">*</span>titulación académica obtenida y realizar la transferencia de los derechos de examen para finalizar el proceso.</li>\n
    <li>Los inscritos que superen el examen recibirán información sobre los requisitos para la concesión de su Certificación EFPA ESG <em>Advisor™</em>. La documentación a aportar les aparecerá en la Web, dentro de su espacio "Acceso Inscripción a Exámenes" en la carpeta "Mis exámenes" cuando consulten su nota.</li>
    <li style="list-style-type:none;font-weight:bold;"><span style="color:red">*¡NOTA!</span> Si ya dispone de alguna de las certificaciones EIP, EFA o EFP de EFPA España, no deberán aportar nuevamente la documentación.</li>
    <ol/>`,
  },
];



export const efpDocuments = [
  {
    name: "Normas de admisión",
    link: "/docs/normas_admision_EFP.pdf",
  },
  {
    name: "Guía de Certificación",
    link: "/docs/GUIA_DE_CERTIFICACION_EFP.pdf",
  },
  {
    name: "Reglas generales",
    link: "/docs/reglas_generales_examenes.pdf",
  },
  {
    name: "Junta de exámenes",
    link: "/docs/junta_de_examenes.pdf",
  },
  {
    name: "Revisión de exámenes",
    link: "/docs/revision_examenes.pdf",
  },
]

export const efaDocuments = [
  {
    name: "Normas de admisión",
    link: "/docs/normas-admision-examenes-EFA.pdf",
  },
  {
    name: "Normas e instrucciones para los exámenes OnLine",
    link: "/docs/NormasExamenesOnLine.pdf",
  },
  {
    name: "Guía de Certificación",
    link: "https://www.efpa.es/descargas/documentos/GUIA_DE_CERTIFICACION_EFA.pdf",
  },
  {
    name: "Reglas generales",
    link: "/docs/reglas_generales_examenes.pdf",
  },
  {
    name: "Junta de exámenes",
    link: "/docs/junta_de_examenes.pdf",
  },
  {
    name: "Revisión de exámenes",
    link: "/docs/revision_examenes.pdf",
  },
]

export const eipDocuments = [
  {
    name: "Normas de admisión",
    link: "/docs/normas-admision-EIP.pdf",
  },
  {
    name: "Guía de Certificación",
    link: "/docs/GUIA_DE_CERTIFICACION_EIP.pdf",
  },
  {
    name: "Reglas generales",
    link: "/docs/reglas_generales_examenes.pdf",
  },
  {
    name: "Normas e instrucciones para los exámenes OnLine",
    link: "/docs/NormasExamenesOnLine.pdf",
  },
  {
    name: "Junta de exámenes",
    link: "/docs/junta_de_examenes.pdf",
  },
  {
    name: "Revisión de exámenes",
    link: "/docs/revision_examenes.pdf",
  },
]

export const eiaDocuments = [
  {
    name: "Normas de admisión",
    link: "/docs/normas-admision-EIA-2021.pdf",
  },
  {
    name: "Normas e instrucciones para los exámenes OnLine",
    link: "/docs/NormasExamenesOnLine.pdf",
  },
  {
    name: "Guía de Certificación",
    link: "/docs/GUIA_DE_CERTIFICACION_EIA.pdf",
  },
  {
    name: "Reglas generales",
    link: "/docs/reglas_generales_examenes.pdf",
  },
  {
    name: "Junta de exámenes",
    link: "/docs/junta_de_examenes.pdf",
  },
  {
    name: "Revisión de exámenes",
    link: "/docs/revision_examenes.pdf",
  },
]

export const esgDocuments = [
  {
    name: "Guía de contenidos",
    link: "/docs/Guia-Contenidos-EFPA-ESG-Advisor.pdf",
  },
  {
    name: "Normas e instrucciones para los exámenes OnLine",
    link: "/docs/NormasExamenesOnLine.pdf",
  },
]

export const certificationEfaTestLevel2 = [
  {
    title: "Definición",
    icon: "fas fa-pen-square",
    content: `<span class="Certification-text">
    La certificación EFPA <em>European Investment Practitioner</em> (EIP) tiene reconocimiento y validez de carácter europeo. Es un nivel intermedio y parcial para la obtención de la siguiente certificación de mayor nivel EFA.
  </span>
  <span class="Certification-text">
    Las horas de formación del certificado EIP (200/240) se entienden como 150 horas lectivas (de clase) y 50/90 horas de autoestudio.
  </span>
  <span class="Certification-text">
    Las personas que obtengan esta certificación tendrán que firmar el código ético y declaración de honorabilidad además de aportar 30 horas de formación continua cada año.
  </span>
  <span class="Certification-text">
    La certificación EFPA <em>European Investment Practitioner</em> (EIP) reconoce la cualificación necesaria para ofrecer asesoramiento habitualmente puntual, de acuerdo a las directrices de ESMA y a los criterios que éstas establecen sobre conocimientos y competencias para asesorar en materia de inversión.
  </span>
  `,
  },
  {
    title: "Estructura examen",
    icon: "fas fa-list",
    content: `<span class="Certification-text">
    El examen EIP consta de 40 preguntas tipo test. Es requisito responder, al menos, el 70% de las preguntas del examen correctamente (28 preguntas), para superar satisfactoriamente la prueba. Las respuestas incorrectas o en blanco no restan puntos. Duración del examen es de 1 hora y 30 minutos.
  </span>
  <span class="Certification-text">
  Una vez superado el examen de la certificación EFPA <em>European Investment Practitioner</em> (EIP) y darse de alta en la asociación, entrarán a formar parte del Registro Europeo de EFPA como EIP. Los que deseen obtener la certificación EFPA European Financial Advisor (EFA)™), podrán hacerlo presentándose, sin límite de años al Examen parcial Nivel II EFA.
  </span>
  <a href="https://www.efpa.es/videotutorial-examen-online"><img src="/imgs/boton-videotutorial-examenesonline.jpg"></a>
  `,
  },
]

export const requirementsLevel2 = [
  {
    title: "Requisitos",
    icon: "far fa-check-square",
    content: `<ol class="numeros engancha">
    <li>Disponer de:<br>
           <strong> a) Titulación</strong>: Educación secundaria post obligatoria (BUP,  Bachillerato, FP) con  la siguiente <strong>experiencia</strong>: Se  requiere 1 año de experiencia para poder obtener la certificación EFA,  o bien, 6 meses, si el candidato ha realizado un curso de preparación en un  centro acreditado<br>
           <br>
O bien<br>
<br>
<strong>b) Titulación:</strong> Educación Secundaria Obligatoria,  con la siguiente experiencia: Se  requieren 5 años de <strong>experiencia</strong> en el sector financiero, debiendo aportar un certificado que lo acredite.<br>
    </li>
<li>Carecer de antecedentes penales por delitos dolosos, no haber sido objeto de expulsión en colegio o asociación profesional y no habérsele impuesto sanción firme por infracción grave en la CNMV.</li>
<li>Realizar la inscripción al examen, a través de la Web, cumplimentando los datos requeridos, adjuntando CV, la última titulación académica obtenida y realizar la transferencia de los derechos de examen para finalizar el proceso.</li>
         <li>Los inscritos que superen el examen recibirán información sobre los requisitos para la concesión de su certificación EFPA. La documentación a aportar les aparecerá en la Web, dentro de su espacio "Acceso Inscripción a Exámenes" en la carpeta "Mis exámenes" cuando consulten su nota.</li>
</ol>`,
  },
]

export const efaDocumentsLevel2 = [
  {
    name: "Normas de admisión",
    link: "/docs/normas-admision-EIP.pdf",
  },
  {
    name: "Normas e instrucciones para los exámenes OnLine",
    link: "/docs/NormasExamenesOnLine.pdf",
  },
  {
    name: "Guía de Certificación",
    link: "/docs/GUIA_DE_CERTIFICACION_EIP.pdf",
  },
  {
    name: "Reglas generales",
    link: "/docs/reglas_generales_examenes.pdf",
  },
  {
    name: "Junta de exámenes",
    link: "/docs/junta_de_examenes.pdf",
  },
  {
    name: "Revisión de exámenes",
    link: "/docs/revision_examenes.pdf",
  },
]

export const certificationEfaTestLevel1 = [
  {
    title: "Definición",
    icon: "fas fa-pen-square",
    content: `<span class="Certification-text">
    Certifica la idoneidad profesional para ejercer tareas de consejo, gestión y asesoría financiera a particulares en banca personal o privada, servicios financieros orientados al cliente individual y cualquier función profesional bancaria, de seguros o independiente, que implique la oferta de un servicio integrado de asesoría patrimonial y financiera.
  </span>
  `,
  },
  {
    title: "Estructura examen",
    icon: "fas fa-list",
    content: `<span class="Certification-text">
    Constará de 2 partes:
  </span>
  <span class="Certification-text">
  La primera, un examen tipo test de 40 preguntas. Para aprobar, el requisito será el haber respondido bien al menos al 70% del examen (28 preguntas). Las respuestas incorrectas o en blanco no restan puntos. Duración de la primera prueba: 1 hora y 30 minutos.
  </span>
  <span class="Certification-text">
  La segunda parte, consistirá en la resolución de ejercicios prácticos sobre distintos aspectos contemplados en el temario EFA. Duración de la segunda prueba: 1 hora.
  En la parte práctica, se valorará no solo la respuesta final seleccionada, sino también la calidad de la explicación y los argumentos en su razonamiento.
  </span>
  <span class="Certification-text">
  Deben aprobarse ambas partes.
  </span>
  <a href="https://www.efpa.es/videotutorial-examen-online"><img src="/imgs/boton-videotutorial-examenesonline.jpg"></a>
  `,
  },
]

export const requirementsLevel1 = [
  {
    title: "Requisitos",
    icon: "far fa-check-square",
    content: `<ol class="numeros engancha">
    <li>Disponer de:<br>
         <strong> a) Titulación</strong>: Educación secundaria post obligatoria (BUP,  Bachillerato, FP) con  la siguiente <strong>experiencia</strong>: Se  requiere 1 año de experiencia para poder obtener la certificación EFA,  o bien, 6 meses, si el candidato ha realizado un curso de preparación en un  centro acreditado<br>
         <br>
O bien<br>
<br>
<strong>b) Titulación:</strong> Educación Secundaria Obligatoria,  con la siguiente experiencia: Se  requieren 5 años de <strong>experiencia</strong> en el sector financiero, debiendo aportar un certificado que lo acredite.</li>
    <li>Disponer de la Certificación EIP en vigor o en su defecto disponer de alguna de las certificaciones y / o titulaciones para asesorar reconocidas por la CNMV (consultar web: <a href="http://www.cnmv.es" target="_blank">www.cnmv.es</a>). A los interesados se les convalidará el requisito de acceso al examen NIVEL II (EFA), no la certificación EIP TM, y deberán:
    <ul style="margin-top: 16px;">
      <li style="list-style:disc;margin-left:16px;">Acreditar la certificación o titulación previa con copia o justificante fehaciente.</li>
      <li style="list-style:disc;margin-left:16px;">Experiencia profesional de, al menos, 6 meses si se ha formado en uno de nuestros centros acreditados, o, en el caso de no ser así, 1 año.</li>
      <li style="list-style:disc;margin-left:16px;">Para poder completar la inscripción al examen NIVEL II, deberá aportar la documentación necesaria para el reconocimiento y así finalizarla.</li>
    </ul>
<li>Carecer de antecedentes penales por delitos dolosos, no haber sido objeto de expulsión en colegio o asociación profesional y no habérsele impuesto sanción firme por infracción grave en la CNMV.</li>
         <li>Los inscritos que superen el examen recibirán información sobre los requisitos para la concesión de su certificación EFPA. La documentación a aportar les aparecerá en la Web, dentro de su espacio "Acceso Inscripción a Exámenes" en la carpeta "Mis exámenes" cuando consulten su nota.</li>
</ol>`,
  },
]

export const efaDocumentsLevel1 = [
  {
    name: "Normas de admisión",
    link: "/docs/normas-admision-examenes-EFA.pdf",
  },
  {
    name: "Normas e instrucciones para los exámenes OnLine",
    link: "/docs/NormasExamenesOnLine.pdf",
  },
  {
    name: "Reglas generales",
    link: "/docs/reglas_generales_examenes.pdf",
  },
  {
    name: "Junta de exámenes",
    link: "/docs/junta_de_examenes.pdf",
  },
  {
    name: "Revisión de exámenes",
    link: "/docs/junta_de_examenes.pdf",
  },
]
